export const odinGlossary = [
  {
    term: 'Biesiada',
    definition:
      'Faza końca rundy, w której zakrywasz wymagany odcinek stołu żywnością i srebrem; użyte dobra wracają do zasobów, luki dają karę.',
    requiredModuleIds: ['base'],
  },
  {
    term: 'Dochód',
    definition:
      'Srebro otrzymywane co rundę z aktywnych linii dochodu na własnych planszach; symbol musi pozostać widoczny.',
    requiredModuleIds: ['base'],
  },
  {
    term: 'Premia',
    definition:
      'Dobro lub zasób pobierany w fazie premii, gdy symbol jest prawidłowo otoczony i odkryty.',
    requiredModuleIds: ['base'],
  },
  {
    term: 'Ulepszenie',
    definition:
      'Odwrócenie posiadanego kafla dobra na jego drugą, lepszą stronę — nie wymiana na inny żeton z puli.',
    requiredModuleIds: ['base'],
  },
  {
    term: 'Wzgórza',
    definition:
      'Pasek materiałów (góry); przy akcji bierzesz kolejne elementy od wskazanej strony, nie ze środka.',
    requiredModuleIds: ['base'],
  },
  {
    term: 'Wielorybnik',
    definition:
      'Mała łódź używana głównie do wielorybnictwa; z Norwegami również do małej emigracji.',
    requiredModuleIds: ['base'],
  },
  {
    term: 'Knara',
    definition:
      'Statek handlowy używany w handlu zamorskim, wyprawach i Grabieży.',
    requiredModuleIds: ['base'],
  },
  {
    term: 'Langskip',
    definition:
      'Okręt wojenny używany do działań militarnych i części wypraw.',
    requiredModuleIds: ['base'],
  },
  {
    term: 'Emigracja',
    definition:
      'Trwałe usunięcie łodzi w zamian za punkty i korzyść przy biesiadzie; ruda na łodzi zwykle przepada.',
    requiredModuleIds: ['base'],
  },
  {
    term: 'Żeton specjalny',
    definition:
      'Nieregularny kafel zdobywany głównie dzięki działaniom militarnym lub rzemiosłu; próg to wartość miecza.',
    requiredModuleIds: ['base'],
  },
  {
    term: 'Wartość miecza',
    definition:
      'Próg wymagany do zdobycia danego żetonu specjalnego; możesz wziąć żeton o wartości równej lub niższej od wyniku.',
    requiredModuleIds: ['base'],
  },
  {
    term: 'Zastawianie pułapek',
    definition:
      'Próba łowiecka według ikon konkretnego pola (kość, broń, dozwolone modyfikatory); osobna od zwykłego polowania.',
    requiredModuleIds: ['base'],
  },
  {
    term: 'Piąta kolumna',
    definition:
      'Kolumna Norwegów, po której użyciu gracz kończy swoje akcje w tej rundzie; 2 wikingów pozwalają zagrać pomocnika.',
    requiredModuleIds: ['base', 'norwegians'],
  },
  {
    term: 'Grabież',
    definition:
      'Akcja Norwegów wymagająca knary; modyfikatory tylko z ikon broni (bez kamieni); nie jest Najazdem ani Plądrowaniem.',
    requiredModuleIds: ['base', 'norwegians'],
  },
  {
    term: 'Mała emigracja',
    definition:
      'Usunięcie wielorybnika w zamian za żeton kładziony na stole biesiadnym; nie jest zwykłą emigracją.',
    requiredModuleIds: ['base', 'norwegians'],
  },
  {
    term: 'Szopa rzemieślnicza',
    definition:
      'Indywidualny budynek z Norwegów; jest szopą, ale nie domem; punkty z łodzi/zwierząt na niej nie liczą się osobno.',
    requiredModuleIds: ['base', 'norwegians'],
  },
  {
    term: 'Klacz',
    definition:
      'Czerwone dobro i zwierzę, rozmnażające się jak owce i krowy ze stroną ciężarną.',
    requiredModuleIds: ['base', 'norwegians'],
  },
  {
    term: 'Świnia',
    definition:
      'Czerwone dobro i zwierzę bez strony ciężarnej; dwie lub więcej dają jedną nową w fazie rozmnażania.',
    requiredModuleIds: ['base', 'norwegians'],
  },
  {
    term: 'Pierwszy gracz',
    definition:
      'Znacznik przechodzi do osoby, która w fazie akcji spasuje jako pierwsza; ta osoba zaczyna fazę akcji w następnej rundzie.',
    requiredModuleIds: ['base'],
  },
  {
    term: 'Blokowanie solo',
    definition:
      'Wikingowie użyci w poprzedniej rundzie pozostają na planszy i blokują pola w kolejnej; zestawy działają naprzemiennie.',
    requiredModuleIds: ['base', 'solo'],
  },
] as const;
